module.exports = __webpack_public_path__ + "img/VirtualCapabilities_00362.2ae39b9a.jpg";